module.exports = {"id":"221174","name":"Mislav Oršić","rating":"75","photo":"./data/images/photos/3/221174.png","club":{"name":"Ulsan Hyundai","logo":"./data/images/clubs/UlsanHyundai.png"},"positions":["MG","AG"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MislavOrsic0.json
// module id = 3056
// module chunks = 0